import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiWebPageTitleComponent } from '@drct-web-apps/ui-web-page-title';



@Component({
  selector: 'ui-web-ministries',
  templateUrl: './ui-web-ministries.component.html',
  imports: [ UiWebPageTitleComponent, CommonModule, RouterModule ]
})
export class UiWebMinistriesComponent {
  @Input() showPageTitle = true;
}
